import React from 'react'
import Interview from './Container'
import {timingFunctionExpand, timingFunctionCollapse} from '../animations'
import interviewList from '../json/interviews'

export default class InterviewView extends React.PureComponent {

  constructor() {
    super()
    this.backToHome = this.backToHome.bind(this)
  }

  componentDidMount() {
    let header = document.querySelector('.interview-header')
    let bg = document.querySelector('section.interviews_lower')
    let footer = document.querySelector('.l-footer.modal-footer')
    let container = document.querySelector('#interview-container')

    let timeScale = 0.5

    let options  = {
      duration: 500 / timeScale,
      easing: timingFunctionExpand,
    }

    // disable scroll for safety
    container.style.overflow = 'hidden'
    bg.style.paddingRight = '17px'

    let flip = new window.FLIP.group([
      {...options, element: bg },
      {...options, element: footer, delay: 200/timeScale },
      {...options, element: header, delay: 200/timeScale },
    ]);

    flip.first()
    flip.last('last')
    flip.invert()
    flip.play()
    setTimeout(() => {
      container.style.overflow = 'auto'
      bg.style.paddingRight = 0
    }, 1000)
  }

  backToHome = () => {
    let header = document.querySelector('.interview-header')
    let footer = document.querySelector('.l-footer.modal-footer')
    let container = document.querySelector('#interview-container')
    let bg = document.querySelector('section.interviews_lower')
    let timeScale = 0.8

    let options  = {
      duration: 500 / timeScale,
      easing: timingFunctionCollapse,
    }

    let flip = new window.FLIP.group([
      {...options, element: bg},
      {...options, element: footer, delay: 200/timeScale },
      {...options, element: header, delay: 500/timeScale  },
    ]);

    // disable scroll for safety
    container.style.overflow = 'hidden'

    flip.first()
    flip.removeClass('last')
    flip.last()
    flip.invert()
    flip.play()
    setTimeout(() => this.props.backToHome(), 400)
  }


  render() {
    let dataId = this.props.interviewData
    let data = interviewList[`interview_${dataId}`]
    return <Interview style={this.props.style} backToHome={this.backToHome}
      dataId={dataId} data={data} />
  }
}


// WEBPACK FOOTER //
// ./src/Interview/index.js